import * as Yup from "yup";

export const projectSchema = Yup.object().shape({
  uid: Yup.number(),
  name: Yup.string().required("대상공정명을 입력하세요"),
  target: Yup.string(),
  workersCount: Yup.number(),
  processNamesSerial: Yup.string().required("공정명을 입력하세요"),
  regionCode: Yup.number(),
  // director: Yup.string().required("관할기관명을 입력하세요"),
  presentLevel: Yup.number(),
  goalLevel: Yup.number(),
  law1: Yup.string().default("산업안전보건법 제44조"),
  law2: Yup.string().default("제2020-55호와 KOSHA GUIDE P-105-2017"),
  isNoPoint: Yup.boolean(),
  isManualPoint: Yup.boolean(),
  isMinusContractor: Yup.boolean(),
  startDate: Yup.date().default(() => new Date()),
  endDate: Yup.date().default(() => new Date()),
  participantsUsers: Yup.array(),
  schedule: Yup.array(),
  // participantsUsersName: Yup.string().required("프로젝트 참여자를 추가하세요"),
});
